import { Chip } from "@mui/material";
import { Datagrid, DateField, FunctionField, List, SelectInput, TextField } from "react-admin";

const KIND_LABEL: Record<string, string> = {
  withdrawal: "Вывод клиенту",
  fee: "Комиссия + маржа",
  activation: "Активация кошелька",
  gas: "Дотация газа",
};

// фильтр по типу операции: служебные (activation/gas) можно отсеять, оставив только вывод денег
const KIND_CHOICES = Object.entries(KIND_LABEL).map(([id, name]) => ({ id, name }));

const filters = [<SelectInput key="kind" source="kind" label="Тип" choices={KIND_CHOICES} alwaysOn />];

const StatusChip = ({ source }: { source: string }) => (
  <FunctionField
    label="Статус"
    render={(r: { status: string }) => {
      const color =
        r.status === "confirmed" ? "success" :
        r.status === "sent" ? "info" :
        r.status === "failed" ? "error" :
        "default";
      return <Chip size="small" color={color as never} label={r[source as keyof typeof r] as string} />;
    }}
  />
);

export function TransactionList() {
  return (
    <List filters={filters} perPage={25} sort={{ field: "created_at", order: "DESC" }} exporter={false}>
      <Datagrid bulkActionButtons={false} rowClick={false}>
        <DateField source="created_at" showTime />
        <FunctionField
          label="Тип"
          render={(r: { kind: string }) => KIND_LABEL[r.kind] || r.kind}
        />
        <FunctionField
          label="Сумма"
          render={(r: { asset: string; amount_usdt: string; amount_trx: string | null }) =>
            r.asset === "TRX"
              ? `${Number(r.amount_trx ?? 0).toFixed(2)} TRX`
              : `${Number(r.amount_usdt).toFixed(2)} USDT`
          }
        />
        <TextField source="from_address" label="Откуда" sx={{ fontFamily: "monospace", fontSize: 12 }} />
        <TextField source="to_address" label="Куда" sx={{ fontFamily: "monospace", fontSize: 12 }} />
        <StatusChip source="status" />
        <TextField source="tx_hash" sx={{ fontFamily: "monospace", fontSize: 11 }} />
        <TextField source="error" />
        <DateField source="confirmed_at" showTime />
      </Datagrid>
    </List>
  );
}
